
define('text!presentation/settings/views/settings.html',[],function () { return '<nav class="main-navigation">\n    Hello\n</nav>\n';});

